module.exports = __webpack_public_path__ + "static/img/icon_xunixianshi_jiaohuliaofa.756da462.png";